<div class="card-summary-title m-b-0 flex flex-horiz-space-bw">
  <h3 class="heading"><i nz-icon nzType="user"></i> <span translate>Agents</span></h3>
  <div>
    <button nz-button nzType="primary" (click)="openAgentOpsModal(null, 'AddAgent')"><i nz-icon nzType="plus"></i> <span
        translate>Agent</span></button>
  </div>
</div>

<!-- <nz-input-group nzCompact>
    <nz-radio-group [(ngModel)]="radioValue" [nzSize]="'small'">
        <label nz-radio-button nzValue="PERSON">Person</label>
        <label nz-radio-button nzValue="ORGANIZATION">Organization</label>
      </nz-radio-group>
      <nz-select nzShowSearch  [(ngModel)]="selectedSearchCriteria">
        <nz-option *ngFor="let criteria of CRITERIALOOKUP" [nzLabel]="criteria.value" [nzValue]="criteria.key"></nz-option>
      </nz-select>
      <input type="text" nz-input [ngModel]="'Xihu District, Hangzhou'" style="width:50%;" />
    </nz-input-group>  -->

<nz-table #basicTable [nzData]="agentsDataSet" [nzSize]="'middle'">
  <thead>
    <tr>
      <th></th>
      <th (click)="sortByColumn('name')" style="cursor: pointer"><span translate>Name</span></th>
      <!--<th (click)="sortByColumn('company')" style="cursor: pointer">Company</th>-->
      <th (click)="sortByColumn('designation')" style="cursor: pointer"><span translate>Designation</span></th>
      <th (click)="sortByColumn('channel')" style="cursor: pointer"><span translate>Channel</span></th>
      <th (click)="sortByColumnByDate('licenseExpiry')" style="cursor: pointer"><span translate>License Validity</span>
      </th>
      <th><span translate>Actions</span></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of basicTable.data">
      <td>
        <nz-avatar nzIcon="user"></nz-avatar>
      </td>
      <td>{{data.name}}</td>
      <!--<td>{{data.company}}</td>-->
      <td>{{data.designation}}</td>
      <td>{{data.channel}}</td>
      <td>
        <nz-badge [nzStatus]="data.licenseExpiryStatus">
          {{data.licenseExpiry}}
        </nz-badge>
      </td>
      <td>
        <a (click)="openAgentOpsModal(data, 'EditAgent')" translate>Edit</a>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="agentModalisVisible" [nzStyle]="{top: '30px'}" [nzMaskClosable]="false" [nzTitle]="modalTitle"
  [nzContent]="modalContent" [nzFooter]="modalFooter" [nzWidth]="860" (nzOnCancel)="handleCancel()">

  <ng-template #modalTitle>
    <span *ngIf="!agentSelected" translate>Add Agent<span *ngIf="validateForm.get('firstName')?.value">:
        {{validateForm.get('firstName')?.value}} {{validateForm.get('lastName')?.value}}</span></span>
    <span *ngIf="agentSelected"><span translate>Edit details for</span> {{agentSelected?.name}}</span>
  </ng-template>

  <ng-template #modalContent>

    <nz-tabset [(nzSelectedIndex)]="agentRegistrationPopupTabIndex" [nzTabPosition]="'top'">

      <nz-tab nzTitle="{{'Details' | translate}}" (nzSelect)="onPage('details')">
        <nz-skeleton [nzAvatar]="true" [nzActive]="true" [nzTitle]="true" [nzLoading]="agentRegistrationIsProcessing">
          <form class="agent-form" id="agent-registration" nz-form [formGroup]="validateForm"
            (ngSubmit)="attemptToSubmit()">

            <!-- AGENT DETAILS -->
            <div>

              <div class="card-summary-title flex flex-horiz-space-bw p-b-0 b-b-0">
                <h3 class="heading m-t-15" ><i nz-icon nzType="solution"></i> <span translate>Basic Details</span>
                  <!-- Agent ID (if user is editing this page) -->
                  <span *ngIf="validateForm.get('agentNum')?.value">Agent ID:
                    {{validateForm.get('agentNum')?.value}}</span>
                </h3>
              </div>

              <!-- Person/Org selection -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('clientTypeCd')"><span translate>Type</span>
                  </nz-form-label>
                  <nz-radio-group formControlName="clientTypeCd" name="clientTypeCd" [nzButtonStyle]="'solid'">
                    <label nz-radio-button nzValue="PERSON"><span translate>Person</span></label>
                    <label nz-radio-button nzValue="ORGANIZATION"><span translate>Organization</span></label>
                  </nz-radio-group>
                </nz-form-item>
                <!-- Agent Type Selection -->
                <nz-form-item *ngIf="validateForm.get('clientTypeCd')?.value=='PERSON'">
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('agentType')"><span translate>Agent Type</span>
                  </nz-form-label>
                  <nz-radio-group formControlName="agentType" name="agentType" [nzButtonStyle]="'solid'">
                    <label nz-radio-button nzValue="INDIVIDUAL"><span translate>Individual Agent</span></label>
                    <label nz-radio-button nzValue="ASSOCIATED"><span translate>Associated Agent</span></label>
                  </nz-radio-group>
                </nz-form-item>
              </div>

              <!-- Org: Extra Details  -->
              <div class="flexie-auto-grid b-1 b-r-5 p-20 p-b-0 m-b-15"
                *ngIf="validateForm.get('clientTypeCd')?.value =='ORGANIZATION'">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('companyName')"><span translate>Company Name</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('companyName'))"
                    [nzSpan]="24">
                    <input nz-input placeholder="{{'Company Name' | translate}}" name="companyName"
                      formControlName="companyName" />
                    <nz-form-explain
                      *ngIf="validateForm.get('companyName').dirty && validateForm.get('companyName').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('companyName'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('contactPerson')"><span translate>Contact Person</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('contactPerson'))"
                    [nzSpan]="24">
                    <input nz-input placeholder="{{'Contact Person' | translate}}" name="contactPerson"
                      formControlName="contactPerson" />
                    <nz-form-explain
                      *ngIf="validateForm.get('contactPerson').dirty && validateForm.get('contactPerson').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('contactPerson'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Associated Agent: Extra Details -->
              <div class="b-1 b-r-5 p-20 p-b-0 m-b-15"
                *ngIf="validateForm.get('clientTypeCd')?.value =='PERSON' && validateForm.get('agentType')?.value =='associated'">
                <div class="flexie-auto-grid">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('partnerName')"><span translate>Partner Name</span></nz-form-label>
                    <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('partnerName'))"
                      [nzSpan]="24">
                      <input nz-input placeholder="{{'Partner Name' | translate}}" name="partnerName"
                        formControlName="partnerName" />
                      <nz-form-explain
                        *ngIf="validateForm.get('partnerName').dirty && validateForm.get('partnerName').errors">
                        <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('partnerName'))">
                          {{error.errorMessage || error }}</p>
                      </nz-form-explain>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('branchName')"><span translate>Branch Name</span></nz-form-label>
                    <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('branchName'))"
                      [nzSpan]="24">
                      <input nz-input formControlName="branchName" placeholder="{{'Branch Name' | translate}}"
                        name="branchName" />
                      <nz-form-explain
                        *ngIf="validateForm.get('branchName').dirty && validateForm.get('branchName').errors">
                        <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('branchName'))">
                          {{error.errorMessage || error }}</p>
                      </nz-form-explain>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="flexie-auto-grid">
                  <div>
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('employeeID')"><span translate>Employee ID</span></nz-form-label>
                      <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('employeeID'))"
                        [nzSpan]="24">
                        <input nz-input placeholder="{{'Employee ID' | translate}}" name="employeeID"
                          formControlName="employeeID" />
                        <nz-form-explain
                          *ngIf="validateForm.get('employeeID').dirty && validateForm.get('employeeID').errors">
                          <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('employeeID'))">
                            {{error.errorMessage || error }}</p>
                        </nz-form-explain>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div>
                  </div>
                </div>

              </div>

              <!-- First and Last Names -->
              <div class="flexie-auto-grid" *ngIf="validateForm.get('clientTypeCd')?.value =='PERSON'">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('firstName')"><span translate>First Name</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('firstName'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'First Name' | translate}}" name="firstName"
                      formControlName="firstName" />
                    <nz-form-explain
                      *ngIf="validateForm.get('firstName').dirty && validateForm.get('firstName').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('firstName'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('lastName')"><span translate>Last Name</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('lastName'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'Last Name' | translate}}" name="lastName"
                      formControlName="lastName" />
                    <nz-form-explain *ngIf="validateForm.get('lastName').dirty && validateForm.get('lastName').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('lastName'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- License Start & End Dates -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('licenseIssueDt')"><span translate>License Issue Date</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('licenseIssueDt'))"
                    [nzSpan]="24">
                    <nz-date-picker class="d-b w-100-pc" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" name="licenseIssueDt"
                      formControlName="licenseIssueDt" (ngModelChange)="nullifyExpiryDate()"></nz-date-picker>
                    <nz-form-explain
                      *ngIf="validateForm.get('licenseIssueDt').dirty && validateForm.get('licenseIssueDt').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('licenseIssueDt'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('licenseExpiryDt')"><span translate>License Expiry Date</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('licenseExpiryDt'))"
                    [nzSpan]="24">
                    <nz-date-picker class="d-b w-100-pc" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" name="licenseExpiryDt"
                      formControlName="licenseExpiryDt" [nzDisabledDate]="disabledExpiryDate"></nz-date-picker>
                    <nz-form-explain
                      *ngIf="validateForm.get('licenseExpiryDt').dirty && validateForm.get('licenseExpiryDt').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('licenseExpiryDt'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- License No. and Agent Category  -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('licenseNum')"><span translate>License No</span>.</nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('licenseNum'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'License No' | translate}}" name="licenseNum"
                      formControlName="licenseNum" />
                    <nz-form-explain
                      *ngIf="validateForm.get('licenseNum').dirty && validateForm.get('licenseNum').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('licenseNum'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('categoryCd')"><span translate>Agent Category</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('categoryCd'))" [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="categoryCd" name="categoryCd" nzAllowClear
                      nzPlaceHolder="{{'Select Category' | translate}}">
                      <nz-option *ngFor="let i of agentCategoryCd" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>
                    <nz-form-explain
                      *ngIf="validateForm.get('categoryCd').dirty && validateForm.get('categoryCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('categoryCd'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Channel and Sub-Channel -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('channelCd')"><span translate>Channel</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('channelCd'))" [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="channelCd" name="channelCd" nzAllowClear
                      nzPlaceHolder="{{'Select Channel' | translate}}">
                      <nz-option *ngFor="let i of channelCdLookup" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>
                    <nz-form-explain
                      *ngIf="validateForm.get('channelCd').dirty && validateForm.get('channelCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('channelCd'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('subChannelCd')"><span translate>Sub Channel</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('subChannelCd'))"
                    [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="subChannelCd" name="subChannelCd" nzAllowClear
                      nzPlaceHolder="{{'Select Sub-Channel' | translate}}">
                      <nz-option *ngFor="let i of subChannelCdLookup" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('subChannelCd').dirty && validateForm.get('subChannelCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('subChannelCd'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Email ID & Status  -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('emailId')"><span translate>Email ID</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('emailId'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'Email ID' | translate}}" name="emailId" formControlName="emailId" />
                    <nz-form-explain *ngIf="validateForm.get('emailId').dirty && validateForm.get('emailId').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('emailId'))">{{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('statusCd')"><span translate>Status</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('statusCd'))" [nzSpan]="24">
                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="statusCd" name="statusCd" nzAllowClear
                      nzPlaceHolder="{{'Select Status' | translate}}">
                      <nz-option *ngFor="let i of userStatusCd" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>
                    <nz-form-explain *ngIf="validateForm.get('statusCd').dirty && validateForm.get('statusCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('statusCd'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Mobile / Work Nos. -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('mobileNum')"><span translate>Mobile Number</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('mobileNum'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'Mobile Number' | translate}}" name="mobileNum"
                      formControlName="mobileNum" />
                    <nz-form-explain
                      *ngIf="validateForm.get('mobileNum').dirty && validateForm.get('mobileNum').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('mobileNum'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('workNum')"><span translate>Work Number</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('workNum'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'Work Number' | translate}}" name="workNum"
                      formControlName="workNum" />
                    <nz-form-explain *ngIf="validateForm.get('workNum').dirty && validateForm.get('workNum').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('workNum'))">{{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Address Line 1 -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('addressLine1')"><span translate>Address (Line 1)</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('addressLine1'))"
                    [nzSpan]="24">
                    <input nz-input placeholder="{{'Address Line 1' | translate}}" name="addressLine1"
                      formControlName="addressLine1" />
                    <nz-form-explain
                      *ngIf="validateForm.get('addressLine1').dirty && validateForm.get('addressLine1').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('addressLine1'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Address Line 2 -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('addressLine2')"><span translate>Address (Line 2)</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('addressLine2'))"
                    [nzSpan]="24">
                    <input nz-input placeholder="{{'Address Line 2' | translate}}" name="addressLine2"
                      formControlName="addressLine2" />
                    <nz-form-explain
                      *ngIf="validateForm.get('addressLine2').dirty && validateForm.get('addressLine2').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('addressLine2'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- POSTAL CODE + Province -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('postCode')"><span translate>Postal Code</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('postCode'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'Postal Code' | translate}}" name="postCode"
                      formControlName="postCode"
                      (ngModelChange)="fetchProvinceAndCityByPostCode(validateForm.get('postCode').value)" />
                    <nz-form-explain *ngIf="validateForm.get('postCode').dirty && validateForm.get('postCode').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('postCode'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('stateCd')"><span translate>Province</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('stateCd'))" [nzSpan]="24">
                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="stateCd" name="stateCd"  nzAllowClear
                      nzPlaceHolder="{{'Select Province' | translate}}"
                      (ngModelChange)="provinceStateCdChanged(validateForm.get('stateCd').value)">
                      <nz-option *ngFor="let i of provinces" [nzValue]="i.provincecd" [nzLabel]="i.provinceName">
                      </nz-option>
                    </nz-select>
                    <nz-form-explain *ngIf="validateForm.get('stateCd').dirty && validateForm.get('stateCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('stateCd'))">{{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <!-- City + Country -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('cityCd')"><span translate>City</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('cityCd'))" [nzSpan]="24">
                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="cityCd" name="cityCd"  nzAllowClear
                      nzPlaceHolder="{{'Select City' | translate}}">
                      <nz-option *ngFor="let i of cityCdLookup" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>
                    <nz-form-explain *ngIf="validateForm.get('cityCd').dirty && validateForm.get('cityCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('cityCd'))">{{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('countryCd')"><span translate>Country</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('countryCd'))" [nzSpan]="24">
                    <!-- <nz-select nzShowSearch  class="d-b w-100-pc" [nzDisabled]="countryCdDdDisabled" formControlName = "countryCd" 
                               name="countryCd"  nzAllowClear nzPlaceHolder="{{'Select Country' | translate}}">
                      <nz-option *ngFor="let i of countryLookup" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue"></nz-option>
                    </nz-select> -->

                    <input nz-input [disabled]="countryCdDdDisabled" value="{{appMetadataHandler.currentCountryCd}}" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <!-- -->

              <label nz-checkbox formControlName="vatApplicableFl" name="vatApplicableFl"><span translate>VAT Applicability</span></label>
              <span class="d-b m-t-10"></span>

            </div>

            <!-- INSURANCE CO. DETAILS -->
            <div>
              <div class="card-summary-title flex flex-horiz-space-bw p-b-0 b-b-0">
                <h3 class="heading m-t-15"><i nz-icon nzType="solution"></i> <span translate>Insurance Company Details</span></h3>
              </div>


              <!-- Desig and Contact Person -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('agentDesignationCd')"> <span
                      translate>Designation</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('agentDesignationCd'))"
                    [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="agentDesignationCd" name="agentDesignationCd"
                      nzAllowClear nzPlaceHolder="{{'Select Designation' | translate}}">
                      <nz-option *ngFor="let i of agentDesignationCd" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('agentDesignationCd').dirty && validateForm.get('agentDesignationCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('agentDesignationCd'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('companyContactUserId')"> <span
                      translate>Contact Person</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('companyContactUserId'))"
                    [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="companyContactUserId" name="companyContactUserId"
                      nzAllowClear nzPlaceHolder="{{'Select Contact Person' | translate}}">
                      <nz-option *ngFor="let i of contactPersonLookup" [nzValue]="i.lookupKey"
                        [nzLabel]="i.lookupValue"></nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('companyContactUserId').dirty && validateForm.get('companyContactUserId').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('companyContactUserId'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Co and Branch -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('companyCd')"> <span translate>Company</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('companyCd'))" [nzSpan]="24">

                    <nz-select nzShowSearch  formControlName="companyCd" class="d-b w-100-pc" name="companyCd" nzAllowClear
                      nzPlaceHolder="{{'Select Company' | translate}}"
                      (ngModelChange)="partnerNamesCompanyChanged(validateForm.get('companyCd').value)">
                      <nz-option *ngFor="let i of partnerNames" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('companyCd').dirty && validateForm.get('companyCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('companyCd'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('companyBranchCd')"> <span
                      translate>Branch</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('companyBranchCd'))"
                    [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="companyBranchCd" name="companyBranchCd"
                      nzMode="multiple" nzAllowClear nzPlaceHolder="{{'Select Branch' | translate}}">
                      <nz-option *ngFor="let i of branchNames" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('companyBranchCd').dirty && validateForm.get('companyBranchCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('companyBranchCd'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
              </div>

              <!-- Division and Sub-Division -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('divisionCd')"> <span translate>Division</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('divisionCd'))" [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="divisionCd" name="divisionCd" nzAllowClear
                      nzPlaceHolder="{{'Select Division' | translate}}"
                      (ngModelChange)="divisionChanged(validateForm.get('divisionCd').value)">
                      <nz-option *ngFor="let i of divisionCdLookup" [nzValue]="i.lookupKey" [nzLabel]="i.lookupValue">
                      </nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('divisionCd').dirty && validateForm.get('divisionCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('divisionCd'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('subDivisionCd')"> <span
                      translate>Sub-Division</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('subDivisionCd'))"
                    [nzSpan]="24">

                    <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="subDivisionCd" name="subDivisionCd" nzAllowClear
                      nzPlaceHolder="{{'Select Sub-Division' | translate}}">
                      <nz-option *ngFor="let i of subDivisionCdFiltered" [nzValue]="i.lookupKey"
                        [nzLabel]="i.lookupValue"></nz-option>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('subDivisionCd').dirty && validateForm.get('subDivisionCd').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('subDivisionCd'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>

                  </nz-form-control>
                </nz-form-item>
              </div>


              <!-- AEGIS Id and Last Names -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('aegisId')"> <span translate>AEGIS ID</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('aegisId'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'AEGIS ID' | translate}}" name="aegisId" formControlName="aegisId" />
                    <nz-form-explain *ngIf="validateForm.get('aegisId').dirty && validateForm.get('aegisId').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('aegisId'))">{{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('cgissId')"> <span translate>CGISS ID</span>
                  </nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('cgissId'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'CGISS ID' | translate}}" name="cgissId" formControlName="cgissId" />
                    <nz-form-explain *ngIf="validateForm.get('cgissId').dirty && validateForm.get('cgissId').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('cgissId'))">{{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <!-- AEGIS Id and Last Names -->
              <div class="flexie-auto-grid">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('integralId')"> <span translate>Integral ID</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('integralId'))" [nzSpan]="24">
                    <input nz-input placeholder="{{'Integral ID' | translate}}" name="integralId"
                      formControlName="integralId" />
                    <nz-form-explain
                      *ngIf="validateForm.get('integralId').dirty && validateForm.get('integralId').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('integralId'))">{{error.errorMessage || error }}
                      </p>
                    </nz-form-explain>
                  </nz-form-control>
                </nz-form-item>
                <div>
                  <!-- Intentionally left blank -->
                </div>
              </div>

            </div>

            <!-- PRODUCTS -->
            <div>
              <div class="card-summary-title flex flex-horiz-space-bw p-b-0 b-b-0">
                <h3 class="heading m-t-15" ><i nz-icon nzType="file-protect"></i> <span translate>Max Acquisition and Commission Distribution</span></h3>
              </div>

              <!-- Product Rows -->
              <div>
                <form nz-form [formGroup]="productForm">
                  <div formArrayName="products">

                    <div class="flexie-auto-grid">
                      <div class="text-a-center">#</div>
                      <div class="text-a-center" translate>Product</div>
                      <div class="text-a-center"><span translate>Max</span>. <span translate>Acquisition Cost</span>
                      </div>
                      <div class="text-a-center" translate>Commission Distribution</div>
                      <div class="text-a-center" translate>Actions</div>
                    </div>

                    <div *ngFor="let itemrow of productForm.controls.products.controls; let i=index"
                      [formGroupName]="i">
                      <div class="flexie-auto-grid">

                        <nz-form-item>
                          <h4 class="text-a-center w-100-pc d-b">{{i+1}}</h4>
                        </nz-form-item>

                        <nz-form-item>
                          <nz-select nzShowSearch  class="d-b w-100-pc" nzAllowClear nzPlaceHolder="{{'Select Product' | translate}}"
                            name="productId" formControlName="productId"
                            style="width: 100%; min-width: 170px; max-width: 170px;">
                            <nz-option *ngFor="let i of productsList" [nzValue]="i.productId" [nzLabel]="i.productName">
                            </nz-option>
                          </nz-select>
                        </nz-form-item>

                        <nz-form-item>
                          <input class="d-b w-100-pc" nz-input placeholder="{{'Max Acquisition Cost' | translate}}"
                            formControlName="productMaxAcqCost" name="productMaxAcqCost" />
                        </nz-form-item>

                        <nz-form-item>
                          <input class="d-b w-100-pc" nz-input placeholder="{{'Commission' | translate}}"
                            formControlName="commDistributionPrct" name="commDistributionPrct" />
                        </nz-form-item>

                        <nz-form-item>
                          <span class="text-a-center d-b w-100-pc"
                            *ngIf="productForm.controls.products.controls.length > 1" (click)="deleteRow(i)"
                            class="clickable" translate><i nz-icon nzType="minus-circle-o"
                              class="dynamic-delete-button"></i>
                            Remove</span>
                        </nz-form-item>

                      </div>
                    </div>

                    <nz-form-item>
                      <button nz-button nzType="dashed" style="width:45%" (click)="addNewRow()" translate><i nz-icon
                          type="plus"></i>
                        Add field</button>
                    </nz-form-item>
                  </div>
                </form>
              </div>

            </div>

            <!-- REPORTING & COMMISSION -->
            <div>
              <div class="card-summary-title flex flex-horiz-space-bw p-b-0 b-b-0">
                <h3 class="heading m-t-15" ><i nz-icon nzType="file-protect"></i> <span translate>Reporting</span></h3>
              </div>

              <div class="flexie-auto-grid">
                <!-- Reporting -->
                <div>
                  <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('managerUserId')"> <span translate>Reporting Manager</span></nz-form-label>
                  <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('managerUserId'))"
                    [nzSpan]="24">
                    <nz-select nzShowSearch  nzAllowClear formControlName="managerUserId" class="d-b w-100-pc" 
                      name="managerUserId" nzPlaceHolder="{{'Reporting Manager' | translate}}">
                      <ng-container *ngFor="let i of agentsListDataSet">
                        <nz-option *ngIf="validateForm.get('agentid').value != i.id" [nzValue]="i.agentId"
                          [nzLabel]="i.name"></nz-option>
                      </ng-container>
                    </nz-select>

                    <nz-form-explain
                      *ngIf="validateForm.get('managerUserId').dirty && validateForm.get('managerUserId').errors">
                      <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('managerUserId'))">
                        {{error.errorMessage || error }}</p>
                    </nz-form-explain>
                  </nz-form-control>

                </div>
                <!-- Commission -->
                <!-- <div>
                  <nz-form-label [nzSpan]="24">Commission</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input nz-input placeholder="{{'Commission' | translate}}" name="commission" formControlName="commission"/>
                  </nz-form-control>
                </div> -->
              </div>
            </div>

            <!-- ROLES -->
            <div>
              <div class="card-summary-title flex flex-horiz-space-bw p-b-0 b-b-0">
                <h3 class="heading m-t-15" ><i nz-icon nzType="file-protect"></i> <span translate>Roles</span></h3>
              </div>



              <div>
                <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('roles')"><span translate>Roles</span>
                </nz-form-label>
                <nz-form-control [nzValidateStatus]="getValidateStatus(validateForm.get('roles'))" [nzSpan]="24">
                  <nz-select nzShowSearch  class="d-b w-100-pc" formControlName="roles" name="roles" nzMode="multiple" nzAllowClear
                    nzPlaceHolder="{{'Choose Roles' | translate}}">
                    <nz-option *ngFor="let role of userRoleCd" [nzValue]="role.lookupKey" [nzLabel]="role.lookupValue">
                    </nz-option>
                  </nz-select>

                  <nz-form-explain *ngIf="validateForm.get('roles').dirty && validateForm.get('roles').errors">
                    <p style="color:red" *ngFor="let error of getErrorList(validateForm.get('roles'))">{{error.errorMessage || error }}</p>
                  </nz-form-explain>
                </nz-form-control>
              </div>

            </div>


            <!-- TEST -- >
            <hr class="m-t-b-20 m-t-40"/>
            <pre>{{ agent | json }}</pre>
            <pre>{{productForm.value | json}}</pre>
            <!-- -->

            <!-- <input nz-button nzType="primary" [nzLoading]="isConfirmLoading" type="submit" nz-button /> -->

          </form>
        </nz-skeleton>
      </nz-tab>

      <!-- Update Reporting v1 -- >
        <nz-tab nzTitle="{{'Update Reporting' | translate}}" (nzSelect)="onPage('update-reporting')">
          <div class="agent-reporting-change">
          <h3 class="heading m-t-20">Copy reporting structure of {{agentSelected?.name}}</h3>
          <div class="flexie-auto-grid">
            <div>
              <div class="m-t-30">
                <h3>{{agentSelected?.name}} reports to</h3>
                <ul>
                  <li>Kewal Vargante - CTO</li>
                </ul>
              </div>
              <div class="m-t-30">
                <h3>Reportees of {{agentSelected?.name}}</h3>
                <ul>
                  <li>Anish S - Salesperson</li>
                  <li>Rahul D - Salesperson</li>
                  <li>Nita A - Salesperson</li>
                  <li>Vivek R - Salesperson</li>
                  <li><a>+ 29 more ...</a></li>
                </ul>
              </div>
            </div>
            <div>
              <h3>Copy {{agentSelected?.name}}'s reporting structure to: </h3>
              <nz-select nzShowSearch  style="width: 300px;"  nzAllowClear nzPlaceHolder="">
                <nz-option nzLabel="" nzValue="jack"></nz-option>
              </nz-select>
              <div class="p-t-b-20 d-b">
                <span class="d-b m-t-10"><label nz-checkbox [(ngModel)]="updateReportsTo">Update `Reports To`</label></span>
                <span class="d-b m-t-20"><label nz-checkbox [(ngModel)]="updateReportees">Update `Reportees`</label></span>
              </div>
  
              <button nz-button nzType="primary">Update reporting</button>
  
            </div>
          </div>
          </div>
        </nz-tab>
        -->

      <!-- Hierarchy -->
      <nz-tab *ngIf="agentSelected" nzTitle="{{'Hierarchy' | translate}}" (nzSelect)="onPage('view-hierarchy')">

        <div class="view-hierarchy" style="width: 100%;overflow-x: scroll;overflow-y: inherit;">
          <h3 class="heading m-t-15">
            <i nz-icon nzType="cluster"></i> <span translate>Reporting structure of</span> {{agentSelected?.name}}
          </h3>

          <nz-skeleton [nzAvatar]="true" [nzActive]="true" [nzTitle]="true" [nzLoading]="agentHierarchyIsProcessing">
            <div class="m-t-40 m-b-100" *ngIf="reportingHierarchy">
              <ng2-org-chart [topEmployee]="reportingHierarchy"></ng2-org-chart>
            </div>
          </nz-skeleton>
        </div>

      </nz-tab>

      <!-- Update Reporting v1 -->
      <nz-tab *ngIf="agentSelected" nzTitle="{{'Update Reporting' | translate}}"
        (nzSelect)="onPage('update-reporting')">
        <div class="agent-reporting-change">
          <h3 class="heading m-t-15"><i nz-icon nzType="cluster"></i> <span translate>Copy reporting structure of</span>
            {{agentSelected?.name}}</h3>
          <div class="flexie-auto-grid">

            <!-- Left Block -->
            <div>
              <div class="m-t-30">
                <h3>{{agentSelected?.name}} <span translate>reports to</span></h3>
                <p>
                  {{agentManager?.name}}
                </p>

              </div>
              <div class="m-t-30">
                <h3><span translate>Reportees of</span> {{agentSelected?.name}}</h3>
                <div *ngIf="0 == agentReportees.length">-</div>
                <div *ngIf="agentReportees.length > 0">
                  <div style="border-bottom: 1px solid rgb(233, 233, 233); padding-bottom: 8px; margin-bottom: 10px;">
                    <label nz-checkbox [(ngModel)]="allChecked" name="reportees" (ngModelChange)="updateAllChecked()"
                      [nzIndeterminate]="indeterminate">
                      <span translate>Check all</span>
                    </label>
                  </div>
                  <nz-checkbox-group [(ngModel)]="agentReportees" name="checkall"
                    (ngModelChange)="updateSingleChecked()" class="checkbox-vertical"></nz-checkbox-group>
                </div>
              </div>
            </div>

            <!-- Right Block -->
            <div>
              <h3><span translate>Copy</span> {{agentSelected?.name}}'s <span translate>reporting structure to</span>:
              </h3>
              <nz-select nzShowSearch  [(ngModel)]="updateReportingOfAgent" style="width: 300px;"  nzAllowClear
                name="updateReportingOfAgent" nzPlaceHolder="{{'Select an Agent' | translate}}">
                <nz-option *ngFor="let i of agentsListDataSet" [nzValue]="i" [nzLabel]="i.name"></nz-option>
              </nz-select>
              <div class="p-t-b-20 d-b">
                <span class="d-b m-t-10">
                  <label nz-checkbox [(ngModel)]="updateReportsTo" [nzDisabled]="!agentHasManager"
                    name="updateReportsTo">
                    <span translate>Copy</span> `Reports To`</label>
                </span>
                <span class="d-b m-t-20">
                  <label nz-checkbox [(ngModel)]="updateReportees" [nzDisabled]="0 == agentReportees.length"
                    name="updateReportees">
                    <span translate>Move selected</span> `Reportees`</label>
                </span>
              </div>

              <button nz-button nzType="primary" (click)="agentHierarchyUpdate()" translate>
                <span translate>Update</span> <span
                  *ngIf="updateReportingOfAgent">{{updateReportingOfAgent?.name}}'s</span> <span
                  translate>reporting</span>
              </button>

            </div>

          </div>
        </div>
      </nz-tab>

    </nz-tabset>

  </ng-template>

  <!-- <ng-template #modalFooter>
      <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">{{actionButtonText}}</button>
    </ng-template> -->
  <ng-template #modalFooter>
    <!-- <button (click)="logMessages()">LOG</button> -->
    <!-- <button nz-button nzType="primary" form="agent-registration" [nzLoading]="isConfirmLoading">Submit</button> -->
    <button *ngIf="'details'==currentTab" nz-button nzType="primary" form="agent-registration"
      [nzLoading]="isConfirmLoading" translate>Save</button>
  </ng-template>

</nz-modal>